module.exports = __webpack_public_path__ + "img/logo.5efe57bc.svg";